module.exports = __webpack_public_path__ + "static/media/003.16d7cf84.svg";